import { HeurekaElementFactory } from "../util/HeurekaElementFactory";
import { events } from "../events";
import type { FilterSectionLoadedEvent } from "../multifiltering/FilterTypes";
import { isActive } from "../toggle/Toggle";
import { updateWhatIfTracking } from "../tracking/WhatIfTracking";

const ID = `heureka_popularFacetValues_whatIf`;

export default class PopularFacetValuesWhatIfTracking {
  static readonly factory = HeurekaElementFactory.byId(ID, PopularFacetValuesWhatIfTracking);

  /*               */
  constructor(readonly elem: HTMLDivElement) {}

  /*               */

  static initAll(event: FilterSectionLoadedEvent, rootElement?: ParentNode) {
    PopularFacetValuesWhatIfTracking.factory.forEach(
      (popularFacetValuesWhatIf) => popularFacetValuesWhatIf.init(),
      rootElement,
    );
  }

  private init() {
    const popularValuesWhatIfTracking = this.popularValuesWhatIfTracking;
    if (popularValuesWhatIfTracking) {
      updateWhatIfTracking(popularValuesWhatIfTracking);
    }
    return this;
  }

  static register() {
    if (isActive("HEUREKA_1728_USE_DAISY_ENDPOINT_FOR_POPVALS_E3515")) {
      events.onFilterSectionLoaded(PopularFacetValuesWhatIfTracking.initAll);
    }
  }

  /*                       */

  get popularValuesWhatIfTracking(): string {
    return this.elem.dataset.popularValuesWhatIf;
  }
}
